import { useEffect, useState } from "react";
import { PasswordGate } from "../components/adresseingabe/PasswordGate";
import { AdresseingabeForm } from "../components/adresseingabe/AdresseingabeForm";
import { HiddenResetButton } from "../components/adresseingabe/HiddenResetButton";
import { useFavicon } from "../hooks/useFavicon";

const TOKEN_KEY = "rk-adresseingabe-token";

/**
 * Simplified flow:
 *  - "gate"  → password screen
 *  - "form"  → directly to the form (customerType always "neu")
 */
export const Adresseingabe = () => {
  useFavicon("/favicon-adresseingabe.svg");
  const [token, setToken] = useState(null);

  useEffect(() => {
    const t = sessionStorage.getItem(TOKEN_KEY);
    if (t) setToken(t);
    document.title = "Adresseingabe · Rechtsanwalt Keller";
  }, []);

  const onAuthSuccess = (t) => {
    sessionStorage.setItem(TOKEN_KEY, t);
    setToken(t);
  };

  const onLogout = () => {
    sessionStorage.removeItem(TOKEN_KEY);
    setToken(null);
  };

  return (
    <div className="min-h-screen bg-[#fafaf7] text-[#0a1128]">
      {!token ? (
        <PasswordGate onSuccess={onAuthSuccess} />
      ) : (
        <AdresseingabeForm
          token={token}
          customerType="neu"
          onUnauthorized={onLogout}
        />
      )}
      <HiddenResetButton rootPath="/adresseingabe" storageKeys={[TOKEN_KEY]} />
    </div>
  );
};
